// ADV-P0I — typed client for the provider-stack health endpoint.
// Same-origin /api/v1 (nginx -> backend :8100). Read-only. No secrets are ever
// returned by the endpoint (key-free by design); this client never sends a key.
import { apiV1Base } from './apiConfig';

export interface ProviderStackHealth {
  active_tier2_provider: string | null;
  tier2_fallback_reason: string | null;
  brave_configured: boolean;
  brave_probe_ok: boolean;
  tavily_enabled: boolean;
  exa_enabled: boolean;
  exa_status: string | null;
  sec_enabled: boolean;
  fmp_configured: boolean;
  tier1_hit_rate: number | null;
  tier2_fallback_rate: number | null;
  total_movers_investigated?: number | null;
  tier2_brave_called_count?: number | null;
  tier2_cache_hit_count?: number | null;
  brave_requests_today: number | null;
  brave_requests_month: number | null;
  brave_cache_hits_today?: number | null;
  brave_estimated_cost_today?: number | null;
  brave_estimated_cost_month: number | null;
  brave_monthly_cap_usd: number | null;
  brave_cap_remaining_estimate: number | null;
}

export async function fetchProviderStackHealth(): Promise<ProviderStackHealth | null> {
  try {
    const res = await fetch(apiV1Base() + '/catalysts/provider-stack-health', { cache: 'no-store' });
    if (!res.ok) return null;
    const j = await res.json();
    return (j && j.data) ? (j.data as ProviderStackHealth) : null;
  } catch {
    return null;
  }
}
